<div
  class="virtual-card d-flex flex-column"
  [ngClass]="{
    'disabled': isDisabled(),
    'mx-auto': isCentered(),
    'skeleton-loader': isLoading(),
    'loaded': !isLoading(),
  }">
  <div class="row align-items-center">
    <div class="col">
      <img
        class="logo"
        src="./assets/logo.svg"
        width="auto"
        height="30"
        alt="Paystashio" />
    </div>
    <div class="col-auto">
      <img
        class="visa"
        ngSrc="./assets/mastercard.svg"
        width="46"
        height="28"
        alt="Mastercard" />
    </div>
  </div>
  <div class="mt-auto">
    <div
      class="card-number"
      [ngClass]="{ 'loading': isLoading() }">
      @if (cardDetail().masked_number) {
        **** **** ****
        {{ cardDetail().masked_number.substring(12) }}
      } @else {
        <span [ngClass]="{ 'loading': isLoading() }"> **** **** **** **** </span>
      }
    </div>
    <div class="row card-details">
      <div class="col-6">
        <div class="detail-label">Card holder</div>
        @if (cardDetail().holder) {
          {{ cardDetail().holder.first_name | emptyIndicator }} {{ cardDetail().holder.last_name | emptyIndicator }}
        } @else {
          <span [ngClass]="{ 'loading': isLoading() }"> **** **** </span>
        }
      </div>
      <div class="col-4 ps-0">
        <div class="detail-label">Expires</div>
        @if (cardExpiry()) {
          {{ cardExpiry() }}
        } @else {
          <span [ngClass]="{ 'loading': isLoading() }"> **/** </span>
        }
      </div>
      <div class="col-2 text-end">
        <div class="detail-label">CVC</div>
        <span [ngClass]="{ 'loading': isLoading() }"> *** </span>
      </div>
    </div>
  </div>
</div>
